export default __webpack_public_path__ + "images/0x9f04b6cefd5bcd67d76ab708f17553ce40188e6a.png";